import React, { useState, useContext, useLayoutEffect } from "react";
import ApiDeviceType from "../../../app/api/admin/device-type/ApiDeviceType";
import Page from "../../modules/page";
import { ContextContent } from "../../modules/content/contentContext";
import InputWrapper from "../../components/input/__wrapper";
import InputText from "../../components/inputs/text";
import InputNumber from "../../components/inputs/number/number";
import InputCheckbox from "../../components/inputs/checkbox";

// Карточка типа устройства (тарифа): show / edit / create одним компонентом
// (режим — contextContent.type). Поля — App\Models\DeviceType / DeviceTypeRequest.
export default function DeviceTypeShow({ ...other }) {
    return <Page ApiModel={ApiDeviceType} withDestroyOnShow={true} {...other}>
        <DeviceTypeShowContent/>
    </Page>;
}

function DeviceTypeShowContent() {
    const contextContent = useContext(ContextContent);

    const [_id, set_id] = useState('');
    const [_name, set_name] = useState('');
    const [_cpuCores, set_cpuCores] = useState('');
    const [_ramMb, set_ramMb] = useState('');
    const [_swapMb, set_swapMb] = useState('');
    const [_diskMb, set_diskMb] = useState('');
    const [_screenW, set_screenW] = useState('');
    const [_screenH, set_screenH] = useState('');
    const [_dpi, set_dpi] = useState('');
    const [_fps, set_fps] = useState('');
    const [_isActive, set_isActive] = useState(true);

    contextContent._dataToServer.current = {
        name: _name,
        cpu_cores: _cpuCores,
        ram_mb: _ramMb,
        swap_mb: _swapMb,
        disk_mb: _diskMb,
        screen_w: _screenW,
        screen_h: _screenH,
        dpi: _dpi,
        fps: _fps,
        is_active: _isActive,
    };
    // Backend-валидация требует эти поля в каждом update (DeviceTypeRequest)
    contextContent._dataRequiredToServer.current = {
        name: _name,
        screen_w: _screenW,
        screen_h: _screenH,
        dpi: _dpi,
        fps: _fps,
    };

    useLayoutEffect(() => {
        contextContent._handleSetData.current = (data) => {
            set_id(data.id);
            set_name(data.name ?? '');
            set_cpuCores(data.cpu_cores ?? '');
            set_ramMb(data.ram_mb ?? '');
            set_swapMb(data.swap_mb ?? '');
            set_diskMb(data.disk_mb ?? '');
            set_screenW(data.screen_w ?? '');
            set_screenH(data.screen_h ?? '');
            set_dpi(data.dpi ?? '');
            set_fps(data.fps ?? '');
            set_isActive(!!data.is_active);
            contextContent.setTitle(`Тип устройства: ${data.name}`);
        };
        if (contextContent.isCreate) contextContent.setTitle('Новый тип устройства');
        contextContent.doLoad();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const readOnly = !contextContent.isCreateOrEdit;
    const errors = contextContent.errors ?? {};

    return <>
        {!contextContent.isCreate ?
            <InputWrapper>
                <InputText className="input_wf" value={_id} readOnly={true}>id</InputText>
            </InputWrapper> : null}

        <InputWrapper>
            <InputText className="input_wf" value={_name} readOnly={readOnly} errors={errors.name}
                placeholder="напр. GVIP · Standard" onChange={(e) => set_name(e.target.value)}>Название</InputText>
        </InputWrapper>
        <InputWrapper>
            <InputNumber className="input_wf" value={_cpuCores} readOnly={readOnly} errors={errors.cpu_cores}
                onChange={(e) => set_cpuCores(e.target.value)}>CPU (ядра)</InputNumber>
        </InputWrapper>
        <InputWrapper>
            <InputNumber className="input_wf" value={_ramMb} readOnly={readOnly} errors={errors.ram_mb}
                onChange={(e) => set_ramMb(e.target.value)}>RAM (МБ)</InputNumber>
        </InputWrapper>
        <InputWrapper>
            <InputNumber className="input_wf" value={_swapMb} readOnly={readOnly} errors={errors.swap_mb}
                onChange={(e) => set_swapMb(e.target.value)}>Swap (МБ)</InputNumber>
        </InputWrapper>
        <InputWrapper>
            <InputNumber className="input_wf" value={_diskMb} readOnly={readOnly} errors={errors.disk_mb}
                onChange={(e) => set_diskMb(e.target.value)}>Диск (МБ)</InputNumber>
        </InputWrapper>
        <InputWrapper>
            <InputNumber className="input_wf" value={_screenW} readOnly={readOnly} errors={errors.screen_w}
                onChange={(e) => set_screenW(e.target.value)}>Ширина экрана</InputNumber>
        </InputWrapper>
        <InputWrapper>
            <InputNumber className="input_wf" value={_screenH} readOnly={readOnly} errors={errors.screen_h}
                onChange={(e) => set_screenH(e.target.value)}>Высота экрана</InputNumber>
        </InputWrapper>
        <InputWrapper>
            <InputNumber className="input_wf" value={_dpi} readOnly={readOnly} errors={errors.dpi}
                onChange={(e) => set_dpi(e.target.value)}>DPI</InputNumber>
        </InputWrapper>
        <InputWrapper>
            <InputNumber className="input_wf" value={_fps} readOnly={readOnly} errors={errors.fps}
                onChange={(e) => set_fps(e.target.value)}>FPS</InputNumber>
        </InputWrapper>
        <InputWrapper>
            <InputCheckbox value={_isActive} readOnly={readOnly}
                onChange={(e) => set_isActive(e.target.checked)}>Активен</InputCheckbox>
        </InputWrapper>
    </>;
}
